import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Select, Space } from "antd";

import DropdownArrow from "../../../assets/img/icons/dropdownarrow.svg";
import Checkbox from "../../Common/Components/Checkbox";
import ButtonSmall from "modules/Common/Components/ButtonSmall";
import SwitchItem from "./SwitchItem";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { postAssetReminder } from "modules/Campaigns/Emails/actions";
import DropDownArrowIcon from "./DropDownArrowIcon";

interface AssetPopoverFormProps {
  cancelClickHandler?: () => void;
  saveReminderClickHandler?: () => void;
}

const AssetPopoverForm: React.FC<AssetPopoverFormProps> = ({ cancelClickHandler, saveReminderClickHandler }) => {
  const { Option } = Select;

  const urlParams = new URLSearchParams(window.location.href);
  const assetId = urlParams.get("asset_id");

  const [frequency, setfrequency] = useState("1");
  const frequencyHandler = (e: any) => {
    setfrequency(e.target.value);
  };

  const [frequencyMode, setfrequencyMode] = useState(1);
  const frequencyModeHandler = (value: number, event: any) => {
    setfrequencyMode(value);
  };

  const [weekday, setWeekday] = useState(1);
  const weekdayHandler = (value: number) => {
    setWeekday(value);
  };

  const [selectValueHours, setSelectValueHours] = useState("10");
  const onSelectHandlerHours = (value: string) => {
    setSelectValueHours(value);
  };

  const [selectValueMinutes, setSelectValueMinutes] = useState("00");
  const onSelectHandlerMinutes = (value: string) => {
    setSelectValueMinutes(value);
  };

  const [selectValueAmPm, setSelectValueAmPm] = useState("am");
  const onSelectHandlerAmPm = (value: string) => {
    setSelectValueAmPm(value);
  };

  const [curationReminder, setCurationReminder] = useState(true);
  const curationReminderHandler = () => {
    setCurationReminder(!curationReminder);
  };

  const [remindBefore, setRemindBefore] = useState("0");
  const remindBeforeHandler = (value: string) => {
    setRemindBefore(value);
  };

  const [isActive, setIsActive] = useState("1");
  const isActiveHandler = (e: any) => {
    if (isActive === "0") setIsActive("1");
    if (isActive === "1") setIsActive("0");
  };

  const convertTime12to24 = (time12h: string) => {
    const [time, modifier] = time12h.split(" ");

    let [hours, minutes] = time.split(":");
    if (hours === "12") {
      hours = "00";
    }
    if (modifier === "pm") {
      hours = (parseInt(hours, 10) + 12)?.toString();
    }
    return `${hours}:${minutes}:00`;
  };
  const reminderTime24Hr = convertTime12to24(`${selectValueHours}:${selectValueMinutes} ${selectValueAmPm}`);

  function convertTime24to12(time: any) {
    // Check correct time format and split into components
    time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      time[5] = +time[0] < 12 ? "am" : "pm"; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(""); // return adjusted time or original string
  }

  const formData = {
    assetId: assetId,
    frequency: frequency,
    frequencyMode: frequencyMode,
    weekday: weekday,
    reminderTime: reminderTime24Hr,
    curationReminder: curationReminder ? "1" : "0",
    remindBefore: remindBefore,
    isActive: isActive,
  };

  const saveClickHandler = () => {
    postAssetReminder(formData);
    saveReminderClickHandler && saveReminderClickHandler();
  };

  const publishReminderData = useSelector((state: RootState) => state.assets.reminder_data);
  console.log("THIS IS PUBLISH REMINDER DATA: ", publishReminderData);

  useEffect(() => {
    if (publishReminderData.success) {
      setfrequency(publishReminderData?.frequency);
      setfrequencyMode(publishReminderData?.frequency_mode);
      setWeekday(publishReminderData?.weekday);
      setSelectValueHours(convertTime24to12(publishReminderData?.reminder_time.split("Z")[0]).split(":")[0]);
      setSelectValueMinutes(convertTime24to12(publishReminderData?.reminder_time.split("Z")[0]).split(":")[1]);
      setSelectValueAmPm(
        convertTime24to12(publishReminderData?.reminder_time.split("Z")[0]).includes("am") ? "am" : "pm"
      );
      setCurationReminder(publishReminderData?.curation_reminder);
      setRemindBefore(publishReminderData?.remind_before);
      setIsActive(publishReminderData?.is_active === true ? "1" : "0");
    }
  }, [publishReminderData]);

  const weekDaysArray = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  const hoursArray = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
  const minutesArray = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
  ];

  return (
    <Wrapper>
      <div className="heading-style">
        <div className="popover-asset-title">Reminders</div>
        <div onClick={isActiveHandler}>
          <SwitchItem isActive={isActive} />
        </div>
      </div>
      <div className="padding-lg">
        <form>
          <div className="form-styling">
            <div className="every padding-bottom-lg padding-left-xl padding-right-xl">
              <Space>
                <span className="filter-label">Every</span>
                <input
                  onChange={frequencyHandler}
                  value={frequency}
                  type="number"
                  className="assetInputNumber"
                  min="1"
                  max="10"
                  style={{ width: "60px" }}
                />
                <Select
                  suffixIcon={DropDownArrowIcon}
                  style={{ width: "105%" }}
                  onSelect={frequencyModeHandler}
                  value={frequencyMode?.toString()}
                >
                  <Option value="1">{"week(s)"}</Option>
                  <Option value="2">{"month(s)"}</Option>
                  <Option value="3">{"year(s)"}</Option>
                </Select>
              </Space>
            </div>
            <div className="on padding-bottom-lg padding-left-xl padding-right-xl">
              <Space>
                <span className="filter-label">On</span>
                <Select
                  suffixIcon={DropDownArrowIcon}
                  onSelect={weekdayHandler}
                  style={{ width: 130 }}
                  value={weekday?.toString()}
                >
                  {weekDaysArray.map((item, index) => (
                    <Option value={(index + 1).toString()}>{item}</Option>
                  ))}
                </Select>
              </Space>
            </div>

            <div className="at padding-bottom-lg padding-left-xl padding-right-xl">
              <Space>
                <span className="filter-label">at</span>
                <Select
                  suffixIcon={DropDownArrowIcon}
                  onSelect={onSelectHandlerHours}
                  value={selectValueHours}
                  style={{ width: 70 }}
                >
                  {hoursArray.map((item, index) => (
                    <Option value={(index + 1).toString()}>{item}</Option>
                  ))}
                </Select>
                <span>:</span>
                <Select
                  suffixIcon={DropDownArrowIcon}
                  onSelect={onSelectHandlerMinutes}
                  value={selectValueMinutes}
                  style={{ width: 70 }}
                >
                  {minutesArray.map((item, index) => (
                    <Option value={index.toString()}>{item}</Option>
                  ))}
                </Select>
                <Select
                  suffixIcon={DropDownArrowIcon}
                  onSelect={onSelectHandlerAmPm}
                  value={selectValueAmPm}
                  style={{ width: 75 }}
                >
                  <Option value="am">am</Option>
                  <Option value="pm">pm</Option>
                </Select>
              </Space>
            </div>
          </div>
          <div className="reminder padding-top-md padding-left-lg">
            <p>
              <span className="margin-right-xs">
                <Checkbox checked={curationReminder} onChange={curationReminderHandler} />
              </span>{" "}
              Remind me to curate content
              <span className="margin-right-sm margin-left-sm">
                <Select
                  suffixIcon={DropDownArrowIcon}
                  onSelect={remindBeforeHandler}
                  value={remindBefore?.toString()}
                  style={{ width: 90 }}
                >
                  <Option value="0">1 day</Option>
                  <Option value="1">2 days</Option>
                  <Option value="2">4 days</Option>
                </Select>
              </span>
              before
            </p>
          </div>
        </form>
      </div>
      <div className="button-styling">
        <Space>
          <ButtonSmall onClick={cancelClickHandler} secondary value="Cancel" />
          <ButtonSmall onClick={saveClickHandler} value="Save changes" />
        </Space>
      </div>
    </Wrapper>
  );
};

export default AssetPopoverForm;

const Wrapper = styled.div`
  .heading-style {
    padding: 2.5px 30px;
    border-radius: 15px 15px 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #ffffff;
  }
  .button-styling {
    display: flex;
    justify-content: center;
    padding-bottom: 30px;
  }
  .form-styling {
    margin-left: -3.3em;
  }
  .assetInputNumber {
    width: 100%;
    border: solid 1px #dadada;
    padding: 5px 12px;
    font-size: 16px;
    color: #7e7e7e;
    font-family: "robotomedium", sans-serif;
    border-radius: 8px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      border-radius: 6px;
      font-size: 12px;
      padding: 4px 12px;
    }
    &:focus,
    &:active {
      outline: none;
    }
  }
  .ant-select {
    .ant-select-selector {
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        border-radius: 6px;
        font-size: 12px;
        height: 28px;
      }
    }
    .ant-select-arrow {
      > div {
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          height: 18px;
        }
      }
    }
  }

  .filter-label {
    font-family: "robotomedium", sans-serif;
    width: 65px;
    display: flex;
    font-size: 18px;
    color: #5e7079;
    justify-content: flex-end;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 13px;
    }
  }
`;

const ArrowIcon = (
  <div
    style={{
      height: "22px",
      paddingLeft: "8px",
      paddingTop: "4px",
      paddingRight: "8px",
      borderLeft: "solid 1px #DDDDDD",
    }}
  >
    <img src={DropdownArrow} />
  </div>
);
